The input parameter for the `positionNotPostedReason` query.
